import { render } from "./DownloadCard.vue?vue&type=template&id=5c9d6120&ts=true"
import script from "./DownloadCard.vue?vue&type=script&lang=ts"
export * from "./DownloadCard.vue?vue&type=script&lang=ts"

import "./DownloadCard.vue?vue&type=style&index=0&id=5c9d6120&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__